import { Injectable } from '@angular/core';
import { EMPTY, Observable, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


import { DialogService } from '@my-aon/shared';
import { hasValue } from '@my-aon/utils';
import { IRole, IUserAccountDto } from '@my-aon/auth';

import { DialogAccountDetailsComponent } from '../../app/dialogs/dialog-account-details/dialog-account-details.component';
import { DialogResetPasswordComponent, } from '../../app/dialogs/dialog-reset-password/dialog-reset-password.component';
import { DialogResetMfaComponent, } from '../../app/dialogs/dialog-reset-mfa/dialog-reset-mfa.component';
import { DialogRoleDetailsComponent } from '../../app/dialogs/dialog-role-details/dialog-role-details.component';

@Injectable({
    providedIn: 'root'
})
export class AdminDialogsService extends DialogService {

    constructor() {

        super();

        this.route.queryParamMap
            .pipe(takeUntilDestroyed())
            .subscribe(params => {
                // Handle query params if needed
                if (params.has('clientPortalAccount')) {
                    let clientPortalAccount: string = params.get('clientPortalAccount') as string;
                    if (clientPortalAccount != 'new')
                        this.openAccountDialog(clientPortalAccount).subscribe();
                }

                if (params.has('roleId')) {
                    let roleId: string = params.get('roleId') as string;
                    if (roleId != 'new')
                        this.openRoleDialog(roleId).subscribe();
                }
            });
    }


    private _account: IUserAccountDto | null = null;
    openAccountDialog(id?: string): Observable<IUserAccountDto | null> {

        if (hasValue(this._account)) return EMPTY;

        this._account = { Id: (id === 'new' ? null : id) } as IUserAccountDto;

        this.dialogRef = this.dialog.open(DialogAccountDetailsComponent, {
            data: {
                data: this._account,
            }
        });

        let queryParams: any = {
            clientPortalAccount: id
        };


        this.setupNavigation([], queryParams);

        return this.dialogRef
            .afterClosed()
            .pipe(tap(() => {
                this.setupNavigation([], { clientPortalAccount: null, });
                this._account = null;
            }))
    }

    private _role: IRole | null = null;
    openRoleDialog(id?: string): Observable<IRole | null> {

        if (hasValue(this._role)) return EMPTY;

        this._role = { Id: (id === 'new' ? null : id) } as IRole;

        this.dialogRef = this.dialog.open(DialogRoleDetailsComponent, {
            data: {
                data: this._role,
            }
        });

        let queryParams: any = {
            roleId: id
        };


        this.setupNavigation([], queryParams);

        return this.dialogRef
        .afterClosed()
        .pipe(tap(() => {
            this.setupNavigation([], { roleId: null, });
            this._role = null;
        }))
    }

    private _resetPassword: IUserAccountDto | null = null;
    openResetPasswordDialog(
        data: IUserAccountDto
    ): Observable<IUserAccountDto | null> {

        if (hasValue(this._resetPassword)) return EMPTY;

        this._resetPassword = data;

        this.dialogRef = this.dialog.open(DialogResetPasswordComponent, {
            data: {
                data: this._resetPassword,
            },
        });

        return this.dialogRef
        .afterClosed()
        .pipe(tap(() => {
            this._resetPassword = null;
        }));
    }

    private _resetMfa: IUserAccountDto | null = null;
    openResetMfaDialog(
        data: IUserAccountDto
    ): Observable<IUserAccountDto | null> {

        if (hasValue(this._resetMfa)) return EMPTY;

        this._resetMfa = data;

        this.dialogRef = this.dialog.open(DialogResetMfaComponent, {
            data: {
                data: this._resetMfa,
            },
        });

        return this.dialogRef
        .afterClosed()
        .pipe(tap(() => {
            this._resetMfa = null;
        }));
    }

}
